//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper";
import {
  postFakeRegister,
  postJwtRegister,
} from "../../../helpers/fakebackend_helper";
import { APIClient } from "../../../helpers/api_helper";

// action
import {
  registerUserSuccessful,
  registerUserFailed,
  resetRegisterFlagChange,
  apiErrorChange
} from "./reducer";

const api = new APIClient();

// initialize relavant method of both Auth
const fireBaseBackend = getFirebaseBackend();

// Is user register successfull then direct plot user in redux.
export const registerUser = (user) => async (dispatch) => {
  try {
    let response;

    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      response = fireBaseBackend.registerUser(user.email, user.password);
      // yield put(registerUserSuccessful(response));
    } else if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
      response = postJwtRegister('/post-jwt-register', user);
      // yield put(registerUserSuccessful(response));
    } else {
      // Send only the required fields to the API
      response = postFakeRegister({
        name: user.name,
        email: user.email,
        password: user.password
      });
      const data = await response;

      // Check if response indicates success
      if (data && data.token) {
        // Backend returned token directly (success)
        dispatch(registerUserSuccessful(data));
      } else if (data && (data.status === "success" || data.message === "success" || data.data)) {
        // Alternative response formats
        dispatch(registerUserSuccessful(data.data || data));
      } else if (data && data.error) {
        // If backend returns explicit error
        dispatch(registerUserFailed(data.error));
      } else {
        // Fallback for unexpected response format
        dispatch(registerUserFailed(data || "Registration failed"));
      }
    }
  } catch (error) {
    dispatch(registerUserFailed(error.message || "Registration failed"));
  }
};

/**
 * Register user with email OTP verification
 */
export const registerUserWithOtp = (user, otp, professionType, referralCode) => async (dispatch) => {
  try {
    const payload = {
      name: user.name,
      email: user.email,
      password: user.password,
      otp: otp,
      professionType: professionType || 'SERVICE_PROFESSIONAL'
    };
    if (referralCode) payload.referralCode = referralCode;
    const response = api.create("/auth/register-with-email-otp", payload);

    const data = await response;

    if (data && data.token) {
      // Ensure isAdmin field is set
      if (!data.isAdmin && data.role) {
        data.isAdmin = data.role === 'admin' || data.role === 'ADMIN';
      }
      
      // Successfully registered with token
      sessionStorage.setItem("authUser", JSON.stringify(data));
      sessionStorage.removeItem("featureFlagsLoaded");
      dispatch(registerUserSuccessful(data));
    } else if (data && (data.status === "success" || data.message === "success" || data.data)) {
      // Ensure isAdmin field is set
      const userData = data.data || data;
      if (!userData.isAdmin && userData.role) {
        userData.isAdmin = userData.role === 'admin' || userData.role === 'ADMIN';
      }
      // Alternative response formats
      sessionStorage.setItem("authUser", JSON.stringify(userData));
      sessionStorage.removeItem("featureFlagsLoaded");
      dispatch(registerUserSuccessful(userData));
    } else if (data && data.error) {
      dispatch(registerUserFailed(data.error));
    } else {
      dispatch(registerUserFailed(data || "Registration failed"));
    }
  } catch (error) {
    const errorMessage = typeof error === 'string' ? error : (error?.message || "Registration failed");
    dispatch(registerUserFailed(errorMessage));
  }
};

export const resetRegisterFlag = () => (dispatch) => {
  dispatch(resetRegisterFlagChange());
};

export const apiError = (message) => (dispatch) => {
  dispatch(apiErrorChange(message));
};